// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';

const smartLists = [
  { id: 'my', name: 'My Lists', description: 'Your saved and shared lists' },
  { id: 'favorites', name: 'Favorites', description: 'Places you loved' },
  { id: 'want', name: 'Want to Try', description: 'Keep a wishlist' },
  { id: 'visited', name: 'Visited', description: 'Track where you’ve been' },
];

export default function ListsHub() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-xl font-semibold">Lists</h1>
        <p className="text-sm text-gray-500">Group your finds into collections. Share with friends.</p>
      </header>

      <section>
        <h2 className="text-sm font-semibold mb-2">Smart lists</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {smartLists.map((l) => (
            <Link key={l.id} to={`/list/${l.id}`} className="block rounded-xl border border-gray-200 dark:border-gray-800 p-4 hover:bg-gray-50 dark:hover:bg-gray-800/50">
              <div className="font-medium">{l.name}</div>
              <div className="text-xs text-gray-500">{l.description}</div>
            </Link>
          ))}
        </div>
      </section>

      <section>
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-sm font-semibold">Your lists</h2>
          <button className="px-3 py-1.5 text-sm rounded bg-blue-600 text-white hover:bg-blue-700">New list</button>
        </div>
        <div className="text-sm text-gray-500">You don’t have any lists yet.</div>
      </section>
    </div>
  );
}
